import BankCodeInput from "./bankCodeInput";

export default class BaseAccountNumberInput<TTarget> extends BankCodeInput<TTarget> {
  protected mask = (value: string) => {
    return Array.from(Array(value?.length + 1 || 1).keys()).map(key => {
      return /.*/;
    });
  };
}
